import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const PromotionApi = createApi({
  reducerPath: "PromotionApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["PROMOTIONS"],
  endpoints: (build) => ({
    getAllPromotions: build.query({
      query: (params) => ({
        url: "/promotions",
        method: "GET",
        params,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PROMOTIONS"],
    }),
    getPromotionById: build.query({
      query: (id) => ({
        url: `/promotions/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: (result, error, id) => [{ type: "PROMOTIONS", id }],
    }),
    createPromotion: build.mutation({
      query: ({ data }) => ({
        url: "/promotions",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PROMOTIONS"],
    }),
    updatePromotion: build.mutation({
      query: ({ id, data }) => ({
        url: `/promotions/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: (result, error, { id }) => ["PROMOTIONS", { type: "PROMOTIONS", id }],
    }),
    deletePromotion: build.mutation({
      query: (id) => ({
        url: `/promotions/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PROMOTIONS"],
    }),
    validatePromotionCode: build.query({
      query: ({ code, ...params }) => ({
        url: `/promotions/validate/${code}`,
        method: "GET",
        params,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
    }),
  }),
});

export const {
  useGetAllPromotionsQuery,
  useGetPromotionByIdQuery,
  useCreatePromotionMutation,
  useUpdatePromotionMutation,
  useDeletePromotionMutation,
  useValidatePromotionCodeQuery,
  useLazyValidatePromotionCodeQuery,
} = PromotionApi;

